var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00001 1.91687e-08C7.6446 0.000115492 6.30887 0.324364 5.10427 0.945694C3.89966 1.56702 2.8611 2.46742 2.07525 3.57175C1.28939 4.67609 0.779019 5.95235 0.586718 7.29404C0.394416 8.63574 0.525759 10.004 0.969788 11.2846C1.41382 12.5652 2.15766 13.7211 3.13925 14.6557C4.12084 15.5904 5.31171 16.2768 6.61252 16.6576C7.91333 17.0384 9.28635 17.1026 10.617 16.8449C11.9477 16.5872 13.1975 16.015 14.262 15.176L17.914 18.828C18.1026 19.0102 18.3552 19.111 18.6174 19.1087C18.8796 19.1064 19.1304 19.0012 19.3158 18.8158C19.5012 18.6304 19.6064 18.3796 19.6087 18.1174C19.611 17.8552 19.5102 17.6026 19.328 17.414L15.676 13.762C16.664 12.5086 17.2792 11.0024 17.4511 9.41573C17.623 7.82905 17.3448 6.22602 16.6482 4.79009C15.9517 3.35417 14.8649 2.14336 13.5123 1.29623C12.1597 0.449106 10.596 -0.000107143 9.00001 1.91687e-08ZM2.50001 8.5C2.50001 6.77609 3.18483 5.12279 4.40382 3.90381C5.6228 2.68482 7.2761 2 9.00001 2C10.7239 2 12.3772 2.68482 13.5962 3.90381C14.8152 5.12279 15.5 6.77609 15.5 8.5C15.5 10.2239 14.8152 11.8772 13.5962 13.0962C12.3772 14.3152 10.7239 15 9.00001 15C7.2761 15 5.6228 14.3152 4.40382 13.0962C3.18483 11.8772 2.50001 10.2239 2.50001 8.5Z",
    fill: "#002222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3dc92ee3c32b7eaaced4ec9f0a369dd1.svg";
export { ForwardRef as ReactComponent };